
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ILoginRequestTM } from '../models/requests/loginRequestTM.interface';
import { IUserTM } from '../models/user/userTM.interface';
import { IOfficeDescription } from '../models/office/officeDescription.interface';
import { UserService } from 'src/app/services/user.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { SettingsService } from 'src/app/services/settings.service';
import { Subject } from 'rxjs';
import { DeployParams } from 'src/app/deployParams';
import { TicketManagerUserProviderService } from './providers/ticketManagerUser.provider.service';
import { environment } from 'src/environments/environment';

@Injectable({providedIn: 'root'})
export class TicketManagerUserService {
  private userTM: IUserTM;
  private tmUserChangedSource = new Subject<void>();
  public tmUserChangedSource$ = this.tmUserChangedSource.asObservable();

  constructor(
    private userProviderTM: TicketManagerUserProviderService,
    private userService: UserService,
    private storage: StorageService,
    private settingsService: SettingsService) {
      this.userTM = storage.userTM;
  }

  get user() {
    return this.userTM;
  }

  setOfficeForUser(loggedOffice: IOfficeDescription) {
    if (this.userTM) {
      this.userTM.loggedOffice = loggedOffice;
      this.storage.userTM = this.userTM;
     // localStorage.setItem('tmUser', JSON.stringify(this.userTM));
      this.tmUserChangedSource.next();
      this.settingsService.reloadSettings();
    }
  }

  login(reqest: ILoginRequestTM): Observable<{ user: IUserTM; allowedOffices: IOfficeDescription[] }> {
    return this.userProviderTM.login(reqest).pipe(
      switchMap(x => {
        this.userTM = {
          userId: x.userId,
          token: x.token,
          userName: x.userName,
          loggedOffice: null,
          p: x.permissions,
          isC: x.isCashier
        };
        this.storage.userTM = this.userTM;
       // localStorage.setItem('tmUser', JSON.stringify(this.userTM));
        // this.tmUserChangedSource.next();
        return of({ user: this.userTM, allowedOffices: x.allowedOffices });
      })
    );
  }

  logout() {
    // remove user from local storage to log user out
    // localStorage.removeItem('tmUser');
    this.userTM = null;
    this.storage.userTM = null;
    this.settingsService.reloadSettings();
    this.tmUserChangedSource.next();
  }

  get officeId(){
    return this.user && this.user.loggedOffice ? this.user.loggedOffice.id : environment.betWebOfficeId;
  }

}
